import { useCallback, useEffect, useRef } from 'react'
import { useGetCodeName } from './useGetCodeName'

export const useCachedGetCodeName = () => {
    const codeNameCache = useRef(new Map<string, string>())
    const getCodeName = useGetCodeName()
    // Clear cache if getCodeName changes
    useEffect(() => {
        codeNameCache.current.clear()
    }, [getCodeName])

    return useCallback(
        (code: string) => {
            if (codeNameCache.current.has(code)) {
                return codeNameCache.current.get(code)!
            }
            const name = getCodeName(code)
            codeNameCache.current.set(code, name)
            return name
        },
        [getCodeName]
    )
}
